import script from "./SimilarPools.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimilarPools.vue?vue&type=script&lang=ts&setup=true"

import "./SimilarPools.vue?vue&type=style&index=0&id=74d94536&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74d94536"]])

export default __exports__